import React, { useCallback, useState } from 'react';

import { messages } from './messages';
import { SimpleModal } from '../../../../../components/simple-modal/simple-modal';
import { useTaxFormContext } from '../../context/tax-form-context-provider';
import { useTaxIdConfig } from '../../hooks/use-tax-id-config';
import { TaxIdentifierForm } from '../tax-identifier-form/tax-identifier-form';
import { TaxIdentifierInformation } from '../tax-identifier-information/tax-identifier-information';

/** @typedef {import('../../types/tax-types').InvoiceAddress} InvoiceAddress */
/** @typedef {import('../../types/tax-types').TaxData} TaxData */

/**
 * @param {object} props
 * @param {() => void} props.onClose
 * @returns {JSX.Element}
 */
export const TaxIdentifierModal = ({ onClose }) => {
  const [isActionDisabled, setIsActionDisabled] = useState(false);
  const { submitTaxForm, closeProcess, issuingAuthority } = useTaxFormContext();
  const { taxIdName, isInvoiceAddressRequired } = useTaxIdConfig(issuingAuthority);

  const handleOnClose = useCallback(() => {
    closeProcess();
    onClose();
  }, [closeProcess, onClose]);

  const handleOnAction = useCallback(() => {
    setIsActionDisabled(true);
    submitTaxForm()
      .then(() => handleOnClose())
      .catch(() => setIsActionDisabled(false))
      .finally(() => setIsActionDisabled(false));
  }, [submitTaxForm, handleOnClose]);

  return (
    <SimpleModal
      actionMessage={messages.actionButton}
      cancelMessage={messages.cancelButton}
      data-testid='tax-identifier-modal'
      headerMessage={isInvoiceAddressRequired ? messages.header : `${taxIdName}`}
      isActionDisabled={isActionDisabled}
      onAction={handleOnAction}
      onCancel={handleOnClose}
      onClose={handleOnClose}
      size='medium'
    >
      <TaxIdentifierInformation />
      <TaxIdentifierForm />
    </SimpleModal>
  );
};
